import * as React from "react";

import {
  Box,
  makeStyles,
  Divider as MuiDivider,
  Theme,
  Typography,
} from "@material-ui/core";

import { useTranslation } from "client/hooks";
import { useNormalizedBrandPaletteValues } from "client/hooks/useNormalizedBrandThemeValues";

const useStyles = makeStyles((theme: Theme) => {
  const { gray50, dividerHr } = useNormalizedBrandPaletteValues(theme);

  return {
    hr: {
      margin: 0,
      flexGrow: 1,
      color: dividerHr,
    },
    or: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      fontSize: "0.9rem",
      color: gray50,
    },
  };
});

export const Divider: React.FC = () => {
  const classes = useStyles();
  console.log("Divider", { classes });
  const t = useTranslation();
  return (
    <Box display="flex" alignItems="center" width="100%">
      <MuiDivider className={classes.hr} />
      <Typography className={classes.or} variant="body2">
        <strong>{t("uiBankDividerOr")}</strong>
      </Typography>
      <MuiDivider className={classes.hr} />
    </Box>
  );
};
